module.exports = "<!-- promo.row.narrow.hbs -->\n<a id=\"message-link\" href=\"Message.htm#{{ id }}\">\n    {{> promobubblenarrow }}\n</a>"